import React, { Component } from 'react'
import FlashCardContainer from './FlashcardContainer'
import FlagCn from './flag_cn.svg'
import FlagEn from './flag_en.svg'
import FlagJp from './flag_jp.svg'
import FlagEs from './flag_es.svg'
import './style.css'


export default class FlashCard extends Component {
	
	state = { catg: 'cn' }
       
    
    catgFx = (val) => {

        this.setState({ catg: val })

    }


	render() {

		const Banner = {
			backgroundImage: 'url("/fcard.jpg")',
			height: '100vh'
        }


		return (

            <div className='WideContainer' style={ Banner }>

                <div className='FcardLang'>
                    <div className='FcardLangBtn' onClick={ () => this.catgFx('cn') } style={{backgroundImage: 'url('+ FlagCn + ')', opacity: this.state.catg === 'cn' ? 0.9 : 0.4 }}></div>
                    <div className='FcardLangBtn' onClick={ () => this.catgFx('en') } style={{backgroundImage: 'url('+ FlagEn + ')', opacity: this.state.catg === 'en' ? 0.9 : 0.4 }}></div>
                    <div className='FcardLangBtn' onClick={ () => this.catgFx('jp') } style={{backgroundImage: 'url('+ FlagJp + ')', opacity: this.state.catg === 'jp' ? 0.9 : 0.4 }}></div>
                    <div className='FcardLangBtn' onClick={ () => this.catgFx('es') } style={{backgroundImage: 'url('+ FlagEs + ')', opacity: this.state.catg === 'es' ? 0.9 : 0.4 }}></div>
                </div>

                <FlashCardContainer catg={ this.state.catg } isLogin = {this.props.isLogin } />

            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/flashcard/index.js